module.exports = __webpack_public_path__ + "static/img/1959_10_DanceMagazine_AnticMeet_2.34eb03f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_10_DanceMagazine_AnticMeet_2.jpg
// module id = 3z+4
// module chunks = 0